module.exports = __webpack_public_path__ + "static/media/rouletteStart_5.6cd5355a.mp3";